import React from 'react'
// import arrow from "../../assets//imgs/buttons/right-arrow.svg"
import './events.scss'
import { Group, Stack } from '@mantine/core'
import AppContainer from '../../component/layout/AppContainer.tsx'
import AppSimpleGrid from '../../component/layout/AppSimpleGrid.tsx'

const EventsBox = () => {
  return (
    <AppContainer>
      <div className="eventBox">
        <div className="boxWrapper-header">
          <h2 className="title__container">Eventos</h2>
          <a className="text__with-color link" href="">
            Ir a eventos{' '}
          </a>
        </div>
        <div className="postBox">
          <div className="postArticle">
            <p className="title__subtitle with-color">
              <span>13 Jul 2023 | Reunión Estación Vic</span>
            </p>
            <p className="text__container">
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
              nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
              erat, sed…
            </p>
            <a className="text__with-color" href="">
              leer más
            </a>
          </div>
          <hr className="separator" />
          <div className="postArticle">
            <p className="title__subtitle with-color">
              <span>
                14 Jul 2023 | Apertura de nueva gasolinera Autonetoil en
                Vilanova
              </span>
            </p>
            <p className="text__container">
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
              nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
              erat, sed…
            </p>
            <a className="text__with-color" href="">
              leer más
            </a>
          </div>
          <hr className="separator" />
          <div className="postArticle">
            <p className="title__subtitle with-color">
              <span>
                14 Jul 2023 | Apertura de nueva gasolinera Autonetoil en
                Vilanova
              </span>
            </p>
            <p className="text__container">
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
              nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
              erat, sed…
            </p>
            <a className="text__with-color" href="">
              leer más
            </a>
          </div>
        </div>
      </div>
    </AppContainer>
  )
}
export default EventsBox
